import imgHero from './img-1600607687939-ce.webp';
import imgTower from './img-1486406146926-c6.webp';
import imgInterior from './img-1600566753190-17.webp';
import imgGlass from './img-1600210492486-72.webp';
import imgFacade from './img-1497366754035-f2.webp';
import imgWorkshop from './img-1581092160607-ee.webp';
import imgDetail from './img-1618220179428-22.webp';
import imgResidence from './img-1600607687920-4e.webp';
import imgOffice from './img-1497215728101-85.webp';
import imgSliding from './img-1512917774080-99.webp';
import imgTermo from './img-1600585154340-be.webp';
import imgWindow from './img-1503387762-592de.webp';
import imgWhite1 from './img-1541123437800-1b.webp';
import imgDark1 from './img-1545324418-cc1a3.webp';
import imgHouse1 from './img-1507089947368-19.webp';
import imgRoom1 from './img-1513694203232-71.webp';
import imgCertificate1 from './certificate1.webp';

// Downloaded specific product images
import imgAkf47 from './akf47.webp';
import imgAldox2 from './aldox2.webp';
import imgEconomAldox from './economAldox.webp';
import imgTermo65 from './termo65.webp';
import imgTermo67 from './termo67.webp';
import imgTermo70 from './termo70.webp';
import imgTermo77 from './termo77.webp';
import imgTermo98 from './termo98.webp';
import imgYwdtermo78 from './ywdtermo78.webp';

import imgBkg40 from './bkg40.webp';
import imgBkh38 from './bkh38.webp';
import imgBkh60 from './bkh60.webp';
import imgBkh65 from './bkh65.webp';

import imgBkf48 from './bkf48.webp';
import imgBkf50 from './bkf50.webp';
import imgBkfMax from './bkfMax.webp';

import imgBko38 from './bko38.webp';
import imgBko40 from './bko40.webp';

import imgSistemAl65 from './sistemAl65.webp';
import imgSistemAl75 from './sistemAl75.webp';
import imgSistemAl85 from './sistemAl85.webp';
import imgAsas64 from './asas64.webp';
import imgAsas75 from './asas75.webp';
import imgGuillotine from './guillotine.webp';

import imgDeceuninck6000 from './Deceuninck6000.webp';
import imgDeceuninck7000 from './Deceuninck7000.webp';
import imgDeceuninck8000 from './Deceuninck8000.webp';

import imgInsideFrameNet from './внутрирамная.webp';
import imgHingedNet from './наПетлях.webp';
import imgSlidingNet from './раздвижная.webp';
import imgFrameNet from './рамочная.webp';

import imgRollerGates from './роллетныеВорота.webp';
import imgRollerShutters from './ролльставни.webp';

import imgSpider from './spider.webp';
import imgSpiderSystem from './spiderSystem.webp';
import imgRailings from './перила.webp';

export const localImages = {
  hero: imgHero,
  tower: imgTower,
  interior: imgInterior,
  glass: imgGlass,
  facade: imgFacade,
  workshop: imgWorkshop,
  detail: imgDetail,
  residence: imgResidence,
  office: imgOffice,
  sliding: imgSliding,
  termo: imgTermo,
  window: imgWindow,
  white1: imgWhite1,
  dark1: imgDark1,
  house1: imgHouse1,
  room1: imgRoom1,
  certificate1: imgCertificate1,

  // Specific product images
  akf47: imgAkf47,
  aldox2: imgAldox2,
  economAldox: imgEconomAldox,
  termo65: imgTermo65,
  termo67: imgTermo67,
  termo70: imgTermo70,
  termo77: imgTermo77,
  termo98: imgTermo98,
  ywdtermo78: imgYwdtermo78,

  bkg40: imgBkg40,
  bkh38: imgBkh38,
  bkh60: imgBkh60,
  bkh65: imgBkh65,

  bkf48: imgBkf48,
  bkf50: imgBkf50,
  bkfMax: imgBkfMax,

  bko38: imgBko38,
  bko40: imgBko40,

  sistemAl65: imgSistemAl65,
  sistemAl75: imgSistemAl75,
  sistemAl85: imgSistemAl85,
  sistemAL85: imgSistemAl85,
  asas64: imgAsas64,
  asas75: imgAsas75,
  guillotine: imgGuillotine,
  deceuninck6000: imgDeceuninck6000,
  deceuninck7000: imgDeceuninck7000,
  deceuninck8000: imgDeceuninck8000,

  // Москитные сетки
  insideFrameNet: imgInsideFrameNet,
  hingedNet: imgHingedNet,
  slidingNet: imgSlidingNet,
  frameNet: imgFrameNet,

  // Роллеты и рольставни
  rollerGates: imgRollerGates,
  rollerShutters: imgRollerShutters,

  // Спайдерные системы и витражи
  spider: imgSpider,
  spiderSystem: imgSpiderSystem,
  railings: imgRailings,
};

export default localImages;

